import { createActionGroup, props, emptyProps } from '@ngrx/store';
import { AppleAirPlaySecurityPreset } from '@rocksoft/mdm-sdk-v2';
import { ErrorModel } from '@era/app';

// ============================================================================
// API ACTIONS (Group - using createActionGroup)
// ============================================================================

export const AirplaySecurityProfileApiActions = createActionGroup({
  source: 'Airplay Security profile API',
  events: {
    'Profiles loaded': props<{ profiles: AppleAirPlaySecurityPreset[] }>(),
    'Profiles loaded error': props<{ error: ErrorModel }>(),
  },
});

// ============================================================================
// RESOLVER ACTIONS (Group - using createActionGroup)
// ============================================================================

export const AirplaySecurityProfileResolverActions = createActionGroup({
  source: 'Airplay Security profile resolver',
  events: {
    'Profiles requested': emptyProps(),
  },
});
